module.exports = __webpack_public_path__ + "img/play_small.b8637285.svg";